import { Button, DIMENSIONS } from '@hqo/react-components-library';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  width: 110px;
  height: 36px;
  padding: 16px;

  @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    width: 100%;
    height: 48px;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    justify-content: center;
  }
`;

export const LocationsListContainer = styled.div`
  .locations-list > div {
    border-bottom: 1px solid ${({ theme }) => theme.colors.greys.adminGreyMedium};
    padding: 16px 16px 16px 10px;
    font-size: 16px;
  }

  .radio-button-title {
    font-weight: 500;
  }
  .radio-button-subtitle {
    font-style: normal;
    color: ${({ theme }) => theme.colors.greys.adminBlack};
  }

  .checkbox-label {
    font-weight: 500;
    margin-top: -6px;
    color: ${({ theme }) => theme.colors.fontColor};
  }

  .checkbox-subtitle {
    font-style: normal;
    color: ${({ theme }) => theme.colors.greys.adminBlack};
  }
`;
